import { Component, OnInit } from '@angular/core';
import {
	AbstractControl,
	FormControl,
	FormGroup,
	ValidationErrors,
	ValidatorFn,
	Validators
} from '@angular/forms';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { PARAM_LABEL_INTERVENANT } from 'src/app/core/services/constant/constants.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';

import { User } from 'src/app/shared/models/security/user';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { DureeExecutionByType, PeriodeExecutionByType, Prestation, PrestationStatut, PrestationType, QualificationEtat } from 'src/app/shared/models/prestation';

@Component({
	selector: 'app-prestation-modal-ajout',
	templateUrl: './prestation-modal-ajout.component.html',
	styleUrls: ['./prestation-modal-ajout.component.scss']
})
export class PrestationModalAjoutComponent implements OnInit {
	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked: { value: boolean } = { value: false };
	isAddressDefault: { value: boolean } = { value: true };
	isAddressSelected: { value: boolean } = { value: false };

	LABEL_INTERVENANT: string;

	MAX_NAME_CHAR = 25;
	NAME_PATTERN = new RegExp("^[0-9a-zA-Z,.'éèàçÀÆæÇÉÈŒœÙ-]+$");
	PHONE_NUMBER_PATTERN = '0{1}[0-9]{9}';

	public prestationStatutEnum = PrestationStatut;
	public qualificationEtatEnum = QualificationEtat;

	formAjout: FormGroup = new FormGroup(
		{
			dateDebut: new FormControl<Date>(null),
			dateAr: new FormControl<Date>(null),
			dateFin: new FormControl<Date>(null),
			statut: new FormControl(''),
			prescripteur: new FormControl(''),
			deDispositifs: new FormControl(''),
			deContraintesHandicap: new FormControl(''),
			deProjetPro: new FormControl(''),
			deRuptureParcours: new FormControl(''),
			deBesoinsIdent: new FormControl(''),
			eeLimites: new FormControl(''),
			eeQuestEmploi: new FormControl(''),
			eeBesoinsAdapt: new FormControl(''),
			eePbAccess: new FormControl(''),
			eeAccompDejaMene: new FormControl(''),
			efLimiteCapacite: new FormControl(''),
			efQuestionnement: new FormControl(''),
			efAccessibilite: new FormControl(''),
			efTypeFormation: new FormControl(''),
			efBesoinsAt: new FormControl(''),
			statutBeneficiaire: new FormControl(''),
			canalCommunication: new FormControl(''),
    		nombreDemande: new FormControl(''),
    		demandePrescripteur: new FormControl(''),
   			reponseDemande: new FormControl(''),
    		typologieDemande: new FormControl(''),
    		situationGeographique: new FormControl(''),
    		typeHandicap: new FormControl(),
			motifRefus: new FormControl(''),
			reorientation: new FormControl(),
			organismeReorientation: new FormControl(''),
			contactReorientation: new FormControl(''),
			argumentaire: new FormControl(''),
			numeroCommande: new FormControl(''),
		}
	);

	user: User;
	prestation = new Prestation();

	constructor(
		private router: Router,
		private logger: LogService,
		private facade: FacadeService,
		public bsModalRef: BsModalRef
	) {}

	ngOnInit(): void {
		this.LABEL_INTERVENANT = this.facade.dataStorageService.getLabelCapitalized(
			PARAM_LABEL_INTERVENANT
		);
		this.user = this.facade.dataStorageService.getUser();
	}

	onSubmit() {
		this.isValidateButtonClicked.value = true;
		this.prestation.statut = this.prestationStatutEnum.OUVERT;
				this.facade.infosasService.addInfosas(this.prestation).subscribe({
					next: (val) => { 
						if(this.prestation.modules.length > 0){
							this.prestation.modules.forEach((currentValue) => {
								switch(currentValue) { 
									case PrestationType.AC: {
										let ac = new Prestation();
										ac.statut = this.prestationStatutEnum.OUVERT;
										ac.beneficiaire = this.prestation.beneficiaire;
										ac.typePrestation = this.prestation.typePrestation;
										ac.service = this.facade.dataStorageService.getService();
										ac.periode = PeriodeExecutionByType[PrestationType.AC];
										ac.duree = DureeExecutionByType[PrestationType.AC];
										ac.idQualification = val.id;
										 
										this.facade.capaciteService.addCapacite(ac).subscribe({
											next: (val) => {
											},
											error: (err) => {
												this.logger.error(err);
											}
										});
										break;
									}
									case PrestationType.AS: {
										let as = new Prestation();
										as.statut = this.prestationStatutEnum.OUVERT;
										as.beneficiaire = this.prestation.beneficiaire;
										as.typePrestation = this.prestation.typePrestation;
										as.service = this.facade.dataStorageService.getService();
										as.periode = PeriodeExecutionByType[PrestationType.AS];
										as.duree = DureeExecutionByType[PrestationType.AS];
										as.idQualification = val.id;
										 
										this.facade.situationPrestationService.addSituationPrestation(as).subscribe({
											next: (val) => {
											},
											error: (err) => {
												this.logger.error(err);
											}
										});
										break;
									}
									case PrestationType.CAMEO: {
										let cameo = new Prestation();
										cameo.statut = this.prestationStatutEnum.OUVERT;
										cameo.beneficiaire = this.prestation.beneficiaire;
										cameo.typePrestation = this.prestation.typePrestation;
										cameo.service = this.facade.dataStorageService.getService();
										cameo.periode = PeriodeExecutionByType[PrestationType.CAMEO];
										cameo.duree = DureeExecutionByType[PrestationType.CAMEO];
										cameo.idQualification = val.id;
										 
										this.facade.miseEnOeuvreEmploiService.addMiseEnOeuvreEmploi(cameo).subscribe({
											next: (val) => {
											},
											error: (err) => {
												this.logger.error(err);
											}
										});
										break;
									}
									case PrestationType.EAP: {
										let eap = new Prestation();
										eap.statut = this.prestationStatutEnum.OUVERT;
										eap.beneficiaire = this.prestation.beneficiaire;
										eap.typePrestation = this.prestation.typePrestation;
										eap.service = this.facade.dataStorageService.getService();
										eap.periode = PeriodeExecutionByType[PrestationType.EAP];
										eap.duree = DureeExecutionByType[PrestationType.EAP];
										eap.idQualification = val.id;
										 
										this.facade.evaluationService.addEvaluation(eap).subscribe({
											next: (val) => {
											},
											error: (err) => {
												this.logger.error(err);
											}
										});
										break;
									}
									case PrestationType.SP: {
										let sp = new Prestation();
										sp.statut = this.prestationStatutEnum.OUVERT;
										sp.beneficiaire = this.prestation.beneficiaire;
										sp.typePrestation = this.prestation.typePrestation;
										sp.service = this.facade.dataStorageService.getService();
										sp.periode = PeriodeExecutionByType[PrestationType.SP];
										sp.duree = DureeExecutionByType[PrestationType.SP];
										sp.idQualification = val.id;
										 
										this.facade.suiviPrecoService.addSuiviPreco(sp).subscribe({
											next: (val) => {
											},
											error: (err) => {
												this.logger.error(err);
											}
										});
										break;
									}
								}
							})
						}
						this.isValidateButtonClicked.value = false;
						this.bsModalRef.hide();
					},
					error: (err: ErrorResponse) => {
						this.isValidateButtonClicked.value = false;
						this.facade.toastService.createHttpErrorToast(
							err.error.message,
							err.status
						);
					}
				});
			
	}
}

